import React from 'react';
import { Trans, t } from '@lingui/macro';
import { AppNotificationBar } from 'components/AppNotificationBar';
import { usePoorStandingBanner } from './usePoorStandingBanner';

const PoorStandingBanner: React.FC = () => {
    const { isPoorStandingVisible, goToAccountBilling, handleDismiss } =
        usePoorStandingBanner();

    if (!isPoorStandingVisible) {
        return null;
    }

    return (
        <AppNotificationBar
            variant="error"
            action={{
                children: t`Retry payment`,
                onClick: goToAccountBilling,
            }}
        >
            <Trans>
                There was a problem billing your account.{' '}
                <a href="#" onClick={handleDismiss}>
                    Dismiss
                </a>
            </Trans>
        </AppNotificationBar>
    );
};

export default PoorStandingBanner;
